module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reservation-flag"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "column text-right"
  }, [_c('span', {
    staticClass: "fa fa-plus",
    on: {
      "click": function($event) {
        _vm.addFlag = !_vm.addFlag
      }
    }
  })])]), (_vm.addFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.flag),
      expression: "body.flag"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "flag", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "TERMINATED_IN_FORBIDDEN"
    }
  }, [_vm._v("Terminated in forbidden")]), _c('option', {
    attrs: {
      "value": "TERMINATED_IN_UNDESIRABLE"
    }
  }, [_vm._v("Terminated in undesirable")]), _c('option', {
    attrs: {
      "value": "HOLD_BILLING"
    }
  }, [_vm._v("Hold billing")]), _c('option', {
    attrs: {
      "value": "SKIP_DEPOSIT"
    }
  }, [_vm._v("Skip deposit")]), _c('option', {
    attrs: {
      "value": "SKIP_BILLING"
    }
  }, [_vm._v("Skip billing")]), _c('option', {
    attrs: {
      "value": "START_ZONES_CONFIG"
    }
  }, [_vm._v("Start zone config")]), _c('option', {
    attrs: {
      "value": "END_ZONES_CONFIG"
    }
  }, [_vm._v("End zone config")]), _c('option', {
    attrs: {
      "value": "EXTRA_COMMON_COST"
    }
  }, [_vm._v("Extra common cost")]), _c('option', {
    attrs: {
      "value": "SKIP_GPS_CHECK"
    }
  }, [_vm._v("Skip GPS check on RT end")]), _c('option', {
    attrs: {
      "value": "FORCE_REFUEL_ACTION"
    }
  }, [_vm._v("Force refuel")]), _c('option', {
    attrs: {
      "value": "FORCE_RECHARGE_ACTION"
    }
  }, [_vm._v("Force recharge")])]), _c('label', [_vm._v("Flag value"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.value),
      expression: "body.value"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "value", $event.target.value)
      }
    }
  })]), _c('ActionButton', {
    attrs: {
      "action": _vm.saveFlag
    }
  }, [_vm._v("Save")])], 1)]) : _vm._e(), _vm._l((_vm.reservation.flags), function(flag) {
    return _c('div', {
      staticClass: "flag"
    }, [_c('span', [_vm._v(_vm._s(flag.flag) + ":")]), _c('div', {
      staticClass: "values"
    }, [_vm._v(_vm._s(flag.value) + " "), _c('ActionButton', {
      attrs: {
        "button": false,
        "action": _vm.editFlag,
        "value": flag
      }
    }, [_c('span', {
      staticClass: "fa fa-pencil"
    }, [_vm._v(" ")]), _c('template', {
      slot: "prompt"
    }, [_c('h2', [_vm._v("Edit flag " + _vm._s(flag.flag))]), _c('label', [_vm._v("Flag value")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (flag.value),
        expression: "flag.value"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (flag.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(flag, "value", $event.target.value)
        }
      }
    })])], 2), _c('ActionButton', {
      attrs: {
        "button": false,
        "confirm": true,
        "action": _vm.deleteFlag,
        "value": flag
      }
    }, [_c('span', {
      staticClass: "fa fa-times"
    })])], 1)])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v("Flags")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3814cbb1!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/ReservationFlag.vue
// module id = 2407
// module chunks = 1